import React from 'react'
import { Tabs,Divider ,Card} from 'antd';
import { BookOutlined, NotificationOutlined,SmileOutlined ,CalendarOutlined,BellOutlined} from '@ant-design/icons';

import AcademicAnnouncements from './academicAnnouncements'

const { TabPane } = Tabs;


const  AnnouncememntsTab =()=>(
    <>
     <Divider
        orientation="left" plain style={{ fontSize: '16px', color: '#08c' }}>
            <BellOutlined  style={{ fontSize: '16px', color: '#08c' }} >
                </BellOutlined> &nbsp;&nbsp;Announcements</Divider>
    <Card style={{padding:"15px",margin:"5px"}}>
    <Tabs defaultActiveKey="1">
    <TabPane
      tab={
        <span>
          <BookOutlined />
         Academic
        </span>
      }
      key="1"
    >
     <AcademicAnnouncements/>
    </TabPane>
    <TabPane
      tab={
        <span>
          <NotificationOutlined />
          Examination
        </span>
      }
      key="2"
    >
      Tab 2
    </TabPane>
    <TabPane
      tab={
        <span>
         <SmileOutlined />
         Cultural
        </span>
      }
      key="3"
    >
      Tab 3
    </TabPane>
    <TabPane
      tab={
        <span>
        <CalendarOutlined />
       Notice
        </span>
      }
      key="4"
    >
      Tab 4
    </TabPane>
  </Tabs>

    </Card>
    </>

)

export default  AnnouncememntsTab